module.exports = __webpack_public_path__ + "img/pms_1.8fac8f60.png";